'use client';

// Import our gsap registration
import './gsap-register';

// This empty file is used to initialize GSAP on the client side
// It's imported in the app layout to ensure GSAP is properly registered with the license 